'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxMessagepanel } from './Messagepanel'
import { MessagepanelProps } from './Messagepanel'

interface MessagepanelBlokProps {
  blok: {
    title: MessagepanelProps['title']
    subtitle: MessagepanelProps['subtitle']
    footer: MessagepanelProps['footer']
    asset?: SbBlokData[]
  } & SbBlokData
}

const Messagepanel: FC<MessagepanelBlokProps> = ({ blok }) => {
  const location = process.env.NEXT_PUBLIC_NEXT_LOCATION ?? ''
  const isAU = location !== 'en-nz'

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxMessagepanel
        title={blok.title ?? ''}
        subtitle={blok.subtitle ?? ''}
        footer={blok.title != null && blok.title !== '' ? (blok.footer ?? '') : ''}
        linkifyPhones={isAU}
        asset={
          blok.asset &&
          blok.asset.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
      />
    </div>
  )
}

export default Messagepanel
